import { createSelector } from 'reselect';

import createSelectors from '../common/utils/selectorUtil';

import * as fromAccuracy from './rctAccuracySelectors';
import * as fromFluComp from './rctFluCompSelectors';

const selectors = {
    ...createSelectors(fromAccuracy, 'accuracy'),
    ...createSelectors(fromFluComp, 'fluComp'),
};

selectors.getRCTState = (state) => state.rct;

selectors.getResultId = createSelector(
    selectors.getRCTState,
    (state) => state.resultId,
);

selectors.getRCTAccuracyState = createSelector(
    selectors.getRCTState,
    (state) => state.accuracy,
);

selectors.getRCTAccuracyPracticeQuestions = (state) => state.questions;

export default selectors;
